import { useEffect } from 'react';

/**
 * Custom hook to handle escape key press for modals
 * @param {Function} onEscape - Callback function to execute when escape key is pressed
 * @param {boolean} isActive - Whether the escape key handler should be active
 */
export const useEscapeKey = (onEscape, isActive = true) => {
  useEffect(() => {
    if (!isActive) return;

    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        onEscape();
      }
    };

    document.addEventListener('keydown', handleEscapeKey);
    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [onEscape, isActive]);
};
